const LISTAR_DADOS = (state, payload) => {
    state.items = payload
}

const CARREGANDO = (state, payload) => {
  state.carregando = payload
}

const INSERIR_HISTORICOSTAR21_SELECIONADA = (state,  payload) => {
  state.selecionado = payload
}

const INSERIR_FICHA_TECNICA = (state,  payload) => {
  state.fichaTecnica = payload
}

const INSERIR_FICHA_TECNICA_TAREFA = (state,  payload) => {
  state.fichaTecnicaTarefa = payload
}

const LIMPAR_FICHA_TECNICA = (state) => {
  state.fichaTecnica = {}
  state.fichaTecnicaTarefa = {}
  state.selecionado = {}
  state.items = []
  state.historicoTicket = null
  state.carregando = false
}

const INSERE_STATUS_CODE_ULTIMA_REQUISICAO = (state, payload) => {
  state.httpStatusCode = payload
}

const INSERIR_HISTORICO_FICHA_TECNICA = (state,  payload) => {  
  let tratamentosData = state.historicoFichaTecnica.tratamentos?.data || []

  tratamentosData.push(...payload.tratamentos.data)

  state.historicoFichaTecnica = {
    ...payload,
    tratamentos: {
      ...payload.tratamentos,
      data: [...tratamentosData]
    }
  }
}

const LIMPAR_HISTORICO_FICHA_TECNICA = (state) => {
  state.historicoFichaTecnica.tratamentos = {
    data: []
  }
}

const INSERIR_HISTORICO_TICKET = (state, payload) => {
  state.historicoTicket = payload
}

const CARREGANDO_OPCOES_TRATATIVAS_TAREFAS = (state, payload) => {
  state.carregandoOpcoesTratativas = payload
}

const LISTA_OPCOES_TRATATIVAS_TAREFAS = (state, payload) => {
  state.opcoesTratativasTarefas = payload
}

const INSERIR_DADOS_ADOCAO = (state, payload) => {
  state.dadosAdocao = payload
}

const CARREGANDO_ADOCAO = (state, payload) => {
  state.carregandoAdocao = payload
}

const CARREGANDO_PCO_TAREFAS = (state, payload) => {
  state.carregandoPcoTarefas = payload
}

const INSERIR_DADOS_PCO_TAREFAS_LOG = (state, payload) => {
  let tarefasData = state.tarefas.data || []

  tarefasData.push(...payload.data)

  state.tarefas = {
    ...payload,
    data: [...tarefasData]
  }
}
const REMOVER_DADOS_PCO_TAREFAS_LOG = (state, payload) => {
  state.tarefas.data = payload
}

const INSERIR_LISTA_TRATATIVAS = (state, payload) => {
  state.listaTratativas = payload
}

export {
    LISTAR_DADOS,
    INSERIR_HISTORICOSTAR21_SELECIONADA,
    CARREGANDO,
    INSERIR_FICHA_TECNICA,
    INSERIR_FICHA_TECNICA_TAREFA,
    LIMPAR_FICHA_TECNICA,
    INSERE_STATUS_CODE_ULTIMA_REQUISICAO,
    INSERIR_HISTORICO_FICHA_TECNICA,
    CARREGANDO_OPCOES_TRATATIVAS_TAREFAS,
    LISTA_OPCOES_TRATATIVAS_TAREFAS,
    INSERIR_DADOS_ADOCAO,
    CARREGANDO_ADOCAO,
    LIMPAR_HISTORICO_FICHA_TECNICA,
    INSERIR_HISTORICO_TICKET,
    CARREGANDO_PCO_TAREFAS,
    INSERIR_DADOS_PCO_TAREFAS_LOG,
    REMOVER_DADOS_PCO_TAREFAS_LOG,
    INSERIR_LISTA_TRATATIVAS
}